import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, font, fontSize, radius } from "../tokens.stylex.ts";

/** A keyboard key, e.g. `<Kbd>⌘</Kbd><Kbd>K</Kbd>`. */
export function Kbd({
  children
}: {
  children: ReactNode;
}) {
  return <kbd className="x3nfvp2 x6s0dn4 xl56j7k xt4ypqs x1qx5ct2 xm9j1uf xmkeg23 x1y0btm7 x4bnxre xlxy82 x1y8ptio x1paulmi xxg9qwl xmccgnw xo5v014 xxe3v3u">{children}</kbd>;
}